import { Injectable } from '@angular/core';
import { ApplicationStateService } from './application-state.service';

@Injectable({
    providedIn: 'root'
})
export class HelpService {

    helpOpened = false;
    externalHelpLink = null;

    constructor(private applicationStateService: ApplicationStateService) {
    }

    /**
     * Check if the help overlay is opened.
     *
     * @returns {boolean}
     */
    isHelpOpened(): boolean {
        return this.helpOpened;
    }

    /**
     * Open the help overlay.
     */
    openHelp(): void {
        this.helpOpened = true;
    }

    /**
     * Close the help overlay.
     */
    closeHelp(): void {
        this.helpOpened = false;
        this.externalHelpLink = null;
    }

    /**
     * Set external help link.
     */
    setExternalHelpLink(externalHelpLink: string): void {
        this.externalHelpLink = externalHelpLink;
    }

    /**
     * Get external help link.
     */
    getExternalHelpLink(): string {
        return this.externalHelpLink;
    }

    /**
     * Get external help link text.
     */
    getExternalHelpLinkText(): string {
        if (this.externalHelpLink === null) {
            return null;
        }

        const platformDomain = this.applicationStateService.platformDomain;
        if (this.externalHelpLink.toLowerCase().indexOf('gm') !== -1) {
            return `Webinaraufzeichnung für Genial! Mathematik auf ${platformDomain} mit Aufgaben-Manager und Kompetenzauswertung`;
        }

        if (this.externalHelpLink.toLowerCase().indexOf('gd') !== -1) {
            return `Webinaraufzeichnung für Genial! Deutsch auf ${platformDomain} mit Aufgaben-Manager und Kompetenzauswertung`;
        }

        return null;
    }
}
